import styled from 'styled-components';
import { StackPanel } from '@agilepoint/wat-react-ux';
import { commonStyles } from 'common';

export const PushNotificationsWrapper = styled(StackPanel)`
    ${commonStyles.boldTextLabel};
    overflow-y: auto;
`;
